import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Tabs} from '@learningblocks/storybook-components';
import {Header} from './Header';
import {TopViewContent} from './TopViewContent';
import {FrontViewContent} from './FrontViewContent';
import {DoneButton} from './DoneButton';
import {TABS} from './ModalWindow.utils';
import {Player} from './Player';
import {MCStateContext} from '..';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  TOP_VIEW: 'TopView.string',
  FRONT_VIEW: 'FrontView.string',
};

export function ModalWindow(props) {
  const {running, pulsing, balanced, isLidOpen} =
    React.useContext(MCStateContext);

  const {t} = useTranslation();

  const tabValidationCheck = () => balanced && !isLidOpen;

  const onClickTab = (tab) => {
    if (tab === TABS.TOP_VIEW) props.setCurrentTab(tab);
    if (tab === TABS.FRONT_VIEW)
      tabValidationCheck() && props.setCurrentTab(tab);
  };

  const invalidClassName =
    props.currentTab != TABS.FRONT_VIEW && !tabValidationCheck()
      ? `--invalid`
      : ``;

  const showAnimation = () => running && !pulsing;

  const renderTabHeading = () => (
    <Tabs.List className=' mc_modal_tab_list '>
      <Tabs.Menu
        className=' mc_modal_tab_list_menu'
        onClick={onClickTab}
        value={TABS.TOP_VIEW}
        key='0'>
        {t(TRANSLATION_KEY.TOP_VIEW)}
      </Tabs.Menu>
      <Tabs.Menu
        className={` mc_modal_tab_list_menu${invalidClassName}`}
        onClick={onClickTab}
        value={TABS.FRONT_VIEW}
        key='1'>
        {t(TRANSLATION_KEY.FRONT_VIEW)}
      </Tabs.Menu>
    </Tabs.List>
  );

  return (
    <Modal
      className='mc_modal'
      isOpen={props.isOpen}
      close={props.closeModal}
      size="sim"
      closeButton={true}>
      <Header className='mc_modal_header' />
      <Tabs.Tabs className=' mc_modal_tab ' default={props.currentTab}>
        {renderTabHeading()}
        <Tabs.Panel
          className=' mc_modal_tab_panel '
          key='1'
          menuValue={TABS.TOP_VIEW}>
          <TopViewContent
            toggleLid={props.toggleLid}
            onDrop={props.onDrop}
            slots={props.slots}
            balanced={props.balanced}
          />
        </Tabs.Panel>
        <Tabs.Panel
          className=' mc_modal_tab_panel '
          key='0'
          menuValue={TABS.FRONT_VIEW}>
          {!showAnimation() && (
            <FrontViewContent
              data={props.frontViewData}
              setRPM={props.setRPM}
              setTimer={props.setTimer}
              onRunCentrifuge={props.onRunCentrifuge}
              onStopCentrifuge={props.onStopCentrifuge}
            />
          )}
          <Player player={props.player} />
        </Tabs.Panel>
      </Tabs.Tabs>
      <DoneButton
        balanced={props.balanced}
        className='mc_modal_doneButton'
        currentTab={props.currentTab}
        setCurrentTab={props.setCurrentTab}
        closeModal={props.closeModal}
      />
    </Modal>
  );
}

ModalWindow.PropTypes = {
  /**
   * tells if modal window is open
   */
  isOpen: PropTypes.bool,
  ...Player.propTypes,
  ...FrontViewContent.propTypes,
  ...DoneButton.propTypes,
  ...TopViewContent.propTypes,
};
